/**
 * @generated SignedSource<<27474f928a3cc5507324d0eb6d761af5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FlyPreviewStatus = "RUNNING" | "STOPPED" | "STARTING" | "DEGRADED" | "%future added value";
export type FlyPreviewTableRow_PreviewQuery$variables = {
  slug: string;
};
export type FlyPreviewTableRow_PreviewQuery$data = {
  readonly viewer: {
    readonly missionControlData: {
      readonly id: string;
      readonly flyPreview: {
        readonly id: string;
        readonly slug: string;
        readonly branchName: string | null;
        readonly webUrl: string;
        readonly status: FlyPreviewStatus;
        readonly machinesTotal: number;
        readonly machinesRunning: number;
        readonly lastUsedAt: string | null;
        readonly lastUsedKnown: boolean;
        readonly createdAt: string | null;
        readonly deployedAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type FlyPreviewTableRow_PreviewQuery = {
  variables: FlyPreviewTableRow_PreviewQuery$variables;
  response: FlyPreviewTableRow_PreviewQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "MissionControlDataType",
  "kind": "LinkedField",
  "name": "missionControlData",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "slug"
        }
      ],
      "concreteType": "FlyPreview",
      "kind": "LinkedField",
      "name": "flyPreview",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "branchName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "machinesTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "machinesRunning",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUsedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUsedKnown",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deployedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FlyPreviewTableRow_PreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FlyPreviewTableRow_PreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9385b3153523cd97f7b72cb0ebfc3388",
    "id": null,
    "metadata": {},
    "name": "FlyPreviewTableRow_PreviewQuery",
    "operationKind": "query",
    "text": "query FlyPreviewTableRow_PreviewQuery(\n  $slug: String!\n) {\n  viewer {\n    missionControlData {\n      id\n      flyPreview(slug: $slug) {\n        id\n        slug\n        branchName\n        webUrl\n        status\n        machinesTotal\n        machinesRunning\n        lastUsedAt\n        lastUsedKnown\n        createdAt\n        deployedAt\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d00918631ab8569f1b8190280130e881";

export default node;
